<template>
    <div
        class="w-full"
        :class="
            state.isFullScreen
                ? 'fixed top-0 z-50 left-0 bottom-0 right-0 h-screen w-screen bg-black p-2 flex items-center justify-center'
                : 'relative '
        "
    >
        <div
            class="w-full max-h-screen flex flex-col items-center justify-center relative overflow-hidden"
        >
            <div
                id="pdfCanvasWrapper"
                class="flex overflow-auto "
                :class="
                    `${
                        state.isFullscreen
                            ? 'w-full h-full'
                            : ' max-h-75vh min-h-75vh w-full'
                    } ${
                        isCanvasOverflowing ? 'justify-start' : 'justify-center'
                    }`
                "
            >
                <canvas
                    ref="pdfContainer"
                    class="w-auto h-full overflow-auto flex-shrink-0"
                ></canvas>
            </div>

            <pdf-actions
                :isFullScreen="state.isFullScreen"
                @toggleFullScreen="toggleFullScreen"
                @nextPage="showNextPage"
                @previousPage="showPreviousPage"
                @zoom-in="zoomPdfIn"
                @zoom-out="zoomPdfOut"
            >
                <div class="flex items-center justify-center text-white">
                    <!-- ! TODO  you can manually change the size and it calls an action when the result is smaller than the last page of the pdf -->
                    <input
                        v-model="pdfState.pageNumber"
                        type="number"
                        id="pageNumberInput"
                        @focus="state.isPageNumberInputFocused = true"
                        @blur="state.isPageNumberInputFocused = false"
                        @keydown="
                            (e) => {
                                if (
                                    (e.keyCode == 38 &&
                                        pdfState.pageNumber >=
                                            state.slide.progress.watch_time) ||
                                    (e.keyCode == 40 &&
                                        pdfState.pageNumber <= 1)
                                ) {
                                    e.preventDefault();
                                }
                            }
                        "
                        @change="
                            (e) => {
                                if (
                                    !state.slide.progress.is_finished &&
                                    e.target.value >=
                                        state.slide.progress.watch_time
                                ) {
                                    pdfState.pageNumber =
                                        state.slide.progress.watch_time;
                                } else if (
                                    e.target.value > pdfState.countPdfPages
                                ) {
                                    pdfState.pageNumber =
                                        pdfState.countPdfPages;
                                } else if (e.target.value <= 0) {
                                    pdfState.pageNumber = 1;
                                }
                                changePage();
                            }
                        "
                        class="w-7  text-center text-white bg-transparent border-b border-white"
                        ref="numberInput"
                    />
                    / {{ pdfState.countPdfPages }}
                </div>
            </pdf-actions>
        </div>

        <custom-button
            v-if="
                hasButton &&
                    !state.isFullScreen &&
                    pdfState.pageNumber == pdfState.countPdfPages &&
                    state.isPageNumberInputFocused == false
            "
            @click="UPDATE_SLIDE_PROGRESS(true)"
            class="w-72 h-11 my-5 ml-6"
            :text="'PDF abschließen'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'text-read-button'"
        />
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    onUnmounted,
    reactive,
    ref,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import { cloneData } from "../../../../../common/dataHelper";
import { base64ToBlobUrl } from "../../../../../common/fileTypeHelper";
import CustomButton from "../../../../../components/input/CustomButton.vue";
import {
    COURSE_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../../../../store/types";
import PdfActions from "./PdfActions.vue";
import { usePdfCanvas } from "./usePdfCanvas";
export default defineComponent({
    name: "PdfCanvas",
    components: { PdfActions, CustomButton },
    props: {
        baseString: {
            required: true,
            type: String,
        },
        hasButton: {
            default: true,
        },
    },
    setup(props) {
        const {
            pdfState,
            setInitialPdfDocument,
            queueRenderPage,
            zoom,
        } = usePdfCanvas();
        const pdfContainer = ref();
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({
            pdfFileUrl: null,
            isFullScreen: false,
            slide: {},
            isPageNumberInputFocused: false,
        });
        /**
         *  Functions
         */
        function changePage() {
            if (typeof pdfState.pageNumber == "string") {
                pdfState.pageNumber = parseInt(pdfState.pageNumber);
            }
            if (
                state.slide &&
                pdfState.pageNumber > state.slide.progress.watch_time
            ) {
                state.slide.progress.watch_time++;
            }
            queueRenderPage();
        }
        function toggleFullScreen() {
            state.isFullScreen = !state.isFullScreen;
            queueRenderPage();
        }

        function zoomPdfIn() {
            zoom(0.25);
            checkIfCanvasIsOverflowing();
        }
        function zoomPdfOut() {
            zoom(-0.25);
            checkIfCanvasIsOverflowing();
        }

        function UPDATE_SLIDE_PROGRESS(isFinished = false) {
            if (
                !isFinished &&
                GET_SLIDE.value &&
                state.slide &&
                GET_SLIDE.value.progress.watch_time >=
                    state.slide.progress.watch_time
            ) {
                return;
            }
            store.dispatch(
                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.UPDATE_SLIDE_PROGRESS}`,
                {
                    watchTime: pdfState.pageNumber, //page
                    slide: state.slide,
                    isFinished,
                }
            );
        }

        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );

        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const COURSE_SECTIONS = computed(() => GET_COURSE.value.sections);
        const CURRENT_SECTION = computed(() =>
            COURSE_SECTIONS.value.find((section) =>
                section.slides.find((slide) => slide.id == GET_SLIDE.value.id)
            )
        );
        const CURRENT_SECTION_SLIDES = computed(
            () => CURRENT_SECTION.value.slides
        );
        const GET_PREVIOUS_SLIDE = computed(() => {
            let previousSlide = {};

            if (GET_SLIDE.value.order != 1) {
                previousSlide = CURRENT_SECTION_SLIDES.value.find(
                    (slide) => slide.order == GET_SLIDE.value.order - 1
                );
            } else {
                let previousSection = {};
                if (CURRENT_SECTION.value.order != 1) {
                    previousSection = COURSE_SECTIONS.value.find(
                        (section) =>
                            (section.order = CURRENT_SECTION.value.order - 1)
                    );
                    previousSlide =
                        previousSection.slides[
                            previousSection.slides.length - 1
                        ];
                } else {
                    previousSlide = null;
                }
            }
            return previousSlide;
        });
        onUnmounted(() => {
            if (timer.value) {
                clearInterval(timer.value);
            }
        });
        /**
         *  Created
         */
        const timer = ref(null);
        onMounted(async () => {
            timer.value = setInterval(() => {
                UPDATE_SLIDE_PROGRESS();
            }, 6000);
            state.slide = cloneData(GET_SLIDE.value);
            const blobFileUrl = base64ToBlobUrl({
                base: props.baseString,
                mimeType: "application/pdf",
            });
            // set pdfFileUrl Url
            state.pdfFileUrl = blobFileUrl;

            await setInitialPdfDocument(state.pdfFileUrl, pdfContainer.value);
            if (state.slide.progress.watch_time) {
                const currentPage =
                    state.slide.progress.watch_time &&
                    state.slide.progress.watch_time > 1
                        ? state.slide.progress.watch_time
                        : 1;
                if (currentPage <= pdfState.countPdfPages) {
                    pdfState.pageNumber = currentPage;
                    queueRenderPage();
                }
            }
        });

        function showNextPage(isPresentorMode = false) {
            if (pdfState.pageNumber != pdfState.countPdfPages) {
                pdfState.pageNumber++;
                changePage();
            } else if (isPresentorMode) {
                if (state.isFullScreen) {
                    window.localStorage.setItem("isFullScreen", "1");
                }
                store.dispatch(`${STORE_TYPES.SLIDES}/finishSlide`, {
                    slideId: state.slide.id,
                    isPresentorMode: isPresentorMode,
                });
            }
        }
        function showPreviousPage(isPresentorMode = false) {
            if (pdfState.pageNumber > 1) {
                pdfState.pageNumber--;
                changePage();
            } else if (isPresentorMode) {
                if (state.isFullScreen) {
                    window.localStorage.setItem("isFullScreen", "1");
                }
                SET_SLIDE();
            }
        }
        // function GET_PREVIOUS_SLIDE() {
        //     const previousSlide = CURRENT_SECTION.value.slides.find(
        //         (slide) => slide.order == GET_SLIDE.value.order - 1
        //     );
        //     return previousSlide;
        // }

        function SET_SLIDE() {
            // Set "showMaterials" = false so the click on the course always navigates to the corresponding course section / slide
            console.log(GET_PREVIOUS_SLIDE.value);
            store.commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SHOW_DOCUMENTS}`,
                false
            );
            store.commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                null
            );
            setTimeout(() => {
                store.commit(
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                    "slide"
                );
                store.commit(
                    `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                    GET_PREVIOUS_SLIDE.value
                );
            }, 100);
        }
        const hasPressedKeyDown = ref(false);
        function handleClickEvent(event) {
            if (hasPressedKeyDown.value == true) {
                return;
            }
            hasPressedKeyDown.value = true;
            if (event.key == "ArrowLeft" || event.key == "PageUp") {
                showPreviousPage(event.key == "PageUp");
                event.preventDefault();
            } else if (event.key == "ArrowRight" || event.key == "PageDown") {
                showNextPage(event.key == "PageDown");
                event.preventDefault();
            }
        }
        function handleKeyUpEvent() {
            hasPressedKeyDown.value = false;
        }

        const isCanvasOverflowing = ref(false);

        function checkIfCanvasIsOverflowing() {
            const element = document.getElementById("pdfCanvasWrapper");
            if (element.scrollWidth > element.clientWidth) {
                isCanvasOverflowing.value = true;
            } else {
                isCanvasOverflowing.value = false;
            }
        }

        onMounted(() => {
            document.addEventListener("keydown", handleClickEvent);
            document.addEventListener("keyup", handleKeyUpEvent);

            // isFullScreen?
            if (window.localStorage.getItem("isFullScreen") == "1") {
                state.isFullScreen = true;
            }
            window.localStorage.setItem("isFullScreen", 0);
        });
        onUnmounted(() => {
            document.removeEventListener("keydown", handleClickEvent);
            document.removeEventListener("keyup", handleKeyUpEvent);
        });
        return {
            state,
            toggleFullScreen,
            UPDATE_SLIDE_PROGRESS,
            GET_SLIDE,
            pdfContainer,
            changePage,
            pdfState,
            showNextPage,
            showPreviousPage,
            zoomPdfIn,
            zoomPdfOut,
            isCanvasOverflowing,
        };
    },
});
</script>
